'use strict';

/**
 * Get responsive source tags
 *
 * @private
 * @param   {Array}  links[]
 * @returns {String}
 */
var getSrcTags, setPictureSources;

getSrcTags = function(links) {
  var sourceTags;
  sourceTags = '';
  links.forEach(function(link) {
    var mediaAttr, ref, srcset;
    srcset = link.urls_by_density.reduceRight(function(collection, item) {
      var density, ref, ref1, url;
      ref1 = (ref = Object.entries(item)[0]) != null ? ref : {}, density = ref1[0], url = ref1[1];
      collection.push(url + " " + density);
      return collection;
    }, []);
    mediaAttr = ((ref = link.media_query) != null ? ref.length : void 0) ? ['media="' + link.media_query, '" '].join('') : '';
    if (srcset.length) {
      return sourceTags += ['<source ', mediaAttr, 'srcset="', srcset.join(', '), '">'].join('');
    }
  });
  return sourceTags;
};


/**
 *
 * @public
 * @param   {Jquery}   $picture - Jquery selector of the picture element
 * @param   {Array}    links    - List of image objects with different resolutions / media queries
 * @param   {Function} cb       - Image load callback (Optional)
 * @returns {Boolean}           - Have the image sources been set
 */

setPictureSources = function($picture, links, $wrapper, image_alt, cb) {
  var $img, defaultImgSrc, smallestImgUrl, sourcetags;
  if (!($picture != null ? $picture.length : void 0)) {
    return false;
  }
  if (!(links != null ? links.length : void 0)) {
    return false;
  }
  smallestImgUrl = links.slice(-1)[0].urls_by_density.slice(-1)[0];
  defaultImgSrc = Object.entries(smallestImgUrl)[0][1];
  sourcetags = getSrcTags(links);
  if (sourcetags != null ? sourcetags.length : void 0) {
    $picture.prepend(sourcetags);
  }
  $img = $picture.find('img');
  if (typeof cb === 'function') {
    $img.one('load', cb);
  }
  $img.attr({
    src: defaultImgSrc,
    alt: image_alt
  });
  if ($wrapper != null) {
    $wrapper.prepend($picture);
  }
  return true;
};

module.exports = {
  setPictureSources: setPictureSources,
  getSrcTags: getSrcTags
};

